/**
 * GA4 dataLayer event names for the new (non-legacy) GTM architecture.
 *
 * Central registry so a `config.events[key]` backend toggle (see
 * `hooks/useGtmEventEnabled`) can never drift from the string actually
 * pushed to the dataLayer.
 *
 * @type {string}
 */
export const EVENT_GA4_VIEW_CART = 'view_cart';
export const EVENT_GA4_ADD_TO_CART = 'add_to_cart';
export const EVENT_GA4_REMOVE_FROM_CART = 'remove_from_cart';
export const EVENT_GA4_CART_OOS_ALERT_SHOWN = 'cart_oos_alert_shown';

export const CART_TYPE_CART = 'cart';
export const CART_TYPE_MINICART = 'minicart';

// remove_from_cart's cart_location — same idea as CART_TYPE_* above, kept
// separate since the spec names it differently and includes 'checkout'
// (unused for now: nothing in the app fires a removal from checkout yet).
export const CART_LOCATION_CART = 'cart';
export const CART_LOCATION_MINICART = 'minicart';
export const CART_LOCATION_CHECKOUT = 'checkout';
